import { useTranslation } from 'react-i18next'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Container } from '@mui/material'

import { EstablishmentForm, EstablishmentFormData } from '@/features/establishment'

export type CreateEstablishmentDialogProps = {
  open: boolean
  onClose: () => void
  onCreateEstablishment: (values: EstablishmentFormData) => void
  isCreating?: boolean
  isEditMode?: boolean
  initialValues?: EstablishmentFormData
}

export function CreateEstablishmentDialogContainer(props: CreateEstablishmentDialogProps) {
  const { open, onClose, onCreateEstablishment, isCreating, isEditMode, initialValues } = props
  const { t } = useTranslation()

  const formId = 'create-establishment-form'

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{isEditMode ? t('page.superAdmin.editEstablishment.title') : t('page.superAdmin.createEstablishmentDialog.title')}</DialogTitle>
      <DialogContent>
        <EstablishmentForm id={formId} onSubmit={onCreateEstablishment} initialValues={initialValues} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common:button.cancel.label')}</Button>
        <Button disabled={isCreating} form={formId} id="add-establishment-button" type="submit" variant="contained" color="primary">
          {isEditMode ? t('common:button.save.label') : t('common:button.submit.label')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CreateEstablishmentDialogContainer
